/* eslint-disable jsx-a11y/anchor-is-valid */
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const navigate = useNavigate();
  const [show, setShow] = React.useState(false);
  const [showModal, setShowModal] = useState(false);
  const [notice, setNotice] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("https://lawacademyadmin.icicle.dev/api/noticeList");
        const sortedNotices = response.data.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setNotice(sortedNotices);
        // console.log(sortedNotices, "SORTED NOTICES");
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/login");
  };
  const clickLogin = () => {
    navigate("/login");
  };

  const isUserLoggedIn = !!localStorage.getItem("user");

  return (
    <div className="header-wrapper header-position">
      <header id="header" className="container-header type1">
        {/* modal */}
        {showModal && (
          <div className="notice_popup">
            <span className="notice-close" onClick={toggleModal}>
              &times;
            </span>
            {notice?.slice(0, 1).map((notice, idx) => (
              <div className="noticeBoard" key={idx}>
                <h2>{notice.title}</h2>
                <h4>{notice.details}</h4>
                {notice.image && (
                  <img
                    className="notice_image"
                    src={`https://lawacademyadmin.icicle.dev/${notice?.image}`}
                    alt=""
                  />
                )}
              </div>
            ))}
          </div>
        )}
        <div className="top-nav">
          <div className="container">
            <div className="row">
              <div className="top-left col-sm-6 hidden-xs">
                <ul className="list-inline">
                  <li>
                    <a href="#">
                      <span className="icon mail-icon"></span>
                      <span className="text">ferozsarkar60@gmail.com</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span className="icon phone-icon"></span>
                      <span className="text">+880 1799-457351</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="top-right col-sm-6 col-xs-12">
                <ul
                  style={{ display: "flex", justifyContent: "end", alignItems: "center", gap: 10 }}
                >
                  <li className="top-search">
                    <form className="navbar-form search no-margin no-padding">
                      <input
                        type="text"
                        name="q"
                        className="form-control input-search"
                        placeholder="search..."
                        autoComplete="off"
                      />
                      <button type="submit" className="lnr lnr-magnifier"></button>
                    </form>
                  </li>

                  <li className="login">
                    {isUserLoggedIn ? (
                      <div className="logout-profile">
                        <button
                          onClick={handleLogout}
                          className="bnt bnt-theme text-regular text-uppercase"
                        >
                          Logout
                        </button>
                        <div className="profileIcon">
                          <Link to="/userprofile">
                            <FontAwesomeIcon icon={faUser} />
                          </Link>
                        </div>
                      </div>
                    ) : (
                      // If user is not logged in, show login button
                      <button
                        onClick={clickLogin}
                        className="bnt bnt-theme text-regular text-uppercase"
                      >
                        Login
                      </button>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="header-middle ">
          <div className="container">
            <div className="menu">
              <div>
                <ul
                  className="bottom-border"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(7, 1fr)",
                    // justifyContent: "center",
                    justifyItems: "center",
                    fontSize: "15px",
                    // alignItems: "center",
                  }}
                >
                  <li style={{ paddingTop: "25px" }}>
                    <Link to="/about">
                      <span>ABOUT US</span>
                    </Link>
                  </li>
                  <li style={{ paddingTop: "25px" }}>
                    <Link to="/memories">
                      <span>MEMORIES</span>
                    </Link>
                  </li>
                  {/* <li style={{ paddingTop: "25px" }}>
                    <Link to="/memories">
                      <span>NOTICE</span>
                    </Link>
                  </li> */}
                  <li style={{ paddingTop: "25px", cursor: "pointer" }}>
                    <div onClick={toggleModal}>
                      <span>NOTICE BOARD</span>
                    </div>
                  </li>
                  <div className="" style={{}}>
                    <Link to="/">
                      {" "}
                      <img
                        style={{ boxShadow: "2px 11px 16px rgba(0, 0, 0, 0.8)" }}
                        width={150}
                        src="/assets/images/logo-header.jpeg"
                        alt="logo"
                      />
                    </Link>
                  </div>

                  <li style={{ paddingTop: "25px" }}>
                    <Link to="/bar-council">
                      <span>BE A STUDENT</span>
                    </Link>
                  </li>
                  <li style={{ paddingTop: "25px" }}>
                    <Link to="/association">
                      <span>ALUMNI</span>
                    </Link>
                  </li>
                  <li style={{ paddingTop: "25px" }}>
                    <Link to="/contacts">
                      <span>CONTACT US</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="area-mobile-content visible-sm visible-xs">
              <div
                className="logo-mobile"
                style={{ display: "flex", width: "100%", justifyContent: "space-between" }}
              >
                <Link to={"/"}>
                  <img
                    className="logo-image-mobile"
                    src="/assets/images/logo-header.jpeg"
                    alt="logo"
                  />
                </Link>
                <>
                  <svg
                    cursor={"pointer"}
                    onClick={() => setShow((prev) => !prev)}
                    width={30}
                    clipRule="evenodd"
                    fillRule="evenodd"
                    strokeLinejoin="round"
                    strokeMiterlimit="2"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="m13 16.75c0-.414-.336-.75-.75-.75h-9.5c-.414 0-.75.336-.75.75s.336.75.75.75h9.5c.414 0 .75-.336.75-.75zm2.195-5.992 2.746 2.999c.142.154.342.243.552.243s.41-.088.553-.242l2.757-2.999c.132-.144.197-.326.197-.507 0-.684-.841-1.008-1.303-.508l-2.202 2.397-2.194-2.396c-.46-.503-1.303-.175-1.303.507 0 .18.065.362.197.506zm-2.195.992c0-.414-.336-.75-.75-.75h-9.5c-.414 0-.75.336-.75.75s.336.75.75.75h9.5c.414 0 .75-.336.75-.75zm0-5c0-.414-.336-.75-.75-.75h-9.5c-.414 0-.75.336-.75.75s.336.75.75.75h9.5c.414 0 .75-.336.75-.75z"
                      fillRule="nonzero"
                    />
                  </svg>
                </>
              </div>
              <div className="mobile-menu mean-container">
                <div className="mean-bar">
                  <span
                    className="meanmenu-reveal mean-menu-tootle"
                    style={{ right: "0", left: "auto" }}
                  ></span>
                  <nav className="mean-nav">
                    <ul className="nav navbar-nav mob-1" style={{ display: !show && "none" }}>
                      <li>
                        <Link to="/about">ABOUT US</Link>
                      </li>
                      <li>
                        <Link to="/memories">MEMORIES</Link>
                      </li>
                      <li>
                        <a onClick={toggleModal}>NOTICE BOARD</a>
                      </li>
                      <li>
                        <Link to="/bar-council">BE A STUDENT</Link>
                      </li>
                      <li>
                        <Link to="/association">ALUMNI</Link>
                      </li>
                      <li>
                        <Link to="/contacts">CONTACT US</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};
export default Header;
